import { gql } from "@apollo/client"

export const CREATE_INWARD_ALLOCATION = gql`
  mutation CreateInwardAllocation($id: ID, $input: InwardAllocationInput!) {
    addUpdateInwardAllocation(id: $id, qualities: $input) {
      inward {
        id
        inward {
          id
        }
        holdingArea {
          id
        }
        plotCommoditySample {
          id
        }
        metadata
      }
    }
  }
`

export const ADD_PACKING_ALLOTMENT = gql`
  mutation MutationAddUpdatePackingAllotment(
    $allotment: PackingAllotmentInput!
    $id: ID
  ) {
    addUpdatePackingAllotment(allotment: $allotment, id: $id) {
      packingAllotment {
        id
      }
    }
  }
`
